import customiz from './custom/customiz.js';
// import woocommerce from './custom/woocommerce.js';
import photoswipe from './custom/photoswipe';
import swiper from './custom/swiper';
import tracking from './custom/tracking.js';
// import scroll from './custom/scroll.js';
import toggle from './custom/toggle.js';
import 'bootstrap/js/dist/tab';


customiz();
photoswipe();
swiper();
// woocommerce();
// tracking();
// scroll();
toggle();